// extracted by mini-css-extract-plugin
export default {"release_details":"ReleaseDetails_release_details__FZ9PD"};